import { Injectable } from '@angular/core';
import { RestApi } from '@core/api/rest.api';
import { RisikoOpkraevningUdestaaende } from './risiko-opkraevning-udestaaende.model';

@Injectable({
  providedIn: 'root',
})
export class OpkraevningUdestaaendeApi extends RestApi<RisikoOpkraevningUdestaaende> {
  endpoint = '/api/admin/risikoopkraevningudestaaender';
}
